export const transformString = (str) => { 
  return str
    .split('/')
    .map(segment => 
      segment
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z-]/g, '')
        .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
        .replace(/^\w/, c => c.toUpperCase())
    )
    .join('/');
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const flattenRoutes = (obj, prefix = "", folderPrefix = "") => {
  let routes = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === "string") {
      routes[`${prefix}${key}`] = `${folderPrefix}${value}`;
    } else {
      const newFolderPrefix = `${folderPrefix}${capitalize(key)}/`;
      Object.assign(routes, flattenRoutes(value, `${prefix}${key}/`, newFolderPrefix));
    }
  });
  return routes;
};

export const mediaDir = (lang) => {
  if (lang === 'es') return 'medios';
  if (lang === 'en') return 'media';
  if (lang === 'pt') return 'midia';
  return '';
};

export const marketsDir = (lang) => {
  if (lang === 'en') return 'markets';
  return 'mercados';
};
